import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconHeart = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.0109 4.9799C16.3396 4.38802 14.1529 4.90271 12.6021 6.98863C12.4613 7.17793 12.2397 7.28999 12.0039 7.29114C11.768 7.29229 11.5453 7.1824 11.4027 6.99447C9.81499 4.90176 7.6247 4.39044 5.96456 4.98062C4.33266 5.56075 3.00261 7.28448 3.28862 10.1446C3.49622 12.2206 4.61864 14.1703 6.13715 15.8679C7.65099 17.5603 9.50886 18.9457 11.074 19.8858C11.6458 20.2293 12.3546 20.2293 12.9264 19.8858C14.4915 18.9457 16.3494 17.5603 17.8632 15.8679C19.3818 14.1703 20.5042 12.2206 20.7118 10.1446C20.9973 7.28915 19.6547 5.56202 18.0109 4.9799ZM18.5116 3.56594C20.8906 4.40844 22.5493 6.84413 22.2043 10.2939C21.9532 12.8049 20.6148 15.0417 18.9812 16.8679C17.343 18.6994 15.3575 20.1753 13.6988 21.1717C12.6517 21.8007 11.3487 21.8007 10.3016 21.1717C8.64291 20.1753 6.65741 18.6994 5.01915 16.8679C3.38556 15.0417 2.04716 12.8049 1.79607 10.2939C1.45157 6.84883 3.08846 4.4111 5.46212 3.56727C7.57471 2.81625 10.0999 3.39257 11.9954 5.37945C13.8679 3.3889 16.3948 2.81629 18.5116 3.56594Z",
		fill: "currentColor"
	})
});
export { SvgIconHeart as ReactComponent };
